@if (isDeveloppement) {
  <div>i'm on SELFCARE !!</div>
}
<br>
<br>
<app-header-preconisation-selfcare [eligibites$]="eligibites$"></app-header-preconisation-selfcare>
<br>
<br>

<ng-container *ngrxLet="{
                  selectTarificationDone:selectTarificationDone$,
                  periodicite:selectPeriodicite$,
                  eligibites:eligibites$,
                  user:selectUser$,
                  produits:selectProduits$,
                  typeHeaderParameters: arTypeHeaderParameters$
                  } as datas">
    <div style="display: flex; justify-content: center;flex-direction: column;align-items: center">
        <div class="header">
            @for (t of datas.typeHeaderParameters; track t.key; let j = $index) {
              <div style="margin-right: 5px">
                  <app-header-selfcare (onChange)="onChangeProduct($event)" [typeHeaderParameters]="t"></app-header-selfcare>
              </div>
            }
            <app-selfcare-text-preco *ngIf="eligibitesEmprunt"></app-selfcare-text-preco>
        </div>
        <br>
        <br>
        @if(datas.eligibites.length > 0) {
          <div class="mensualites" [ngStyle]="datas.typeHeaderParameters | SizeBottomExpansion : eligibitesEmprunt">
              <div style="display: flex; flex-direction: row;justify-content: flex-end;align-items:center;width: 100%">
                  Mensualités à partir de {{datas.selectTarificationDone | MntFormattedPipe : 'GLOBAL' : datas.periodicite}}<sup>3</sup>
                  <button (click)="accordion()" [class.active]="isActive" class="accordion">
                      <div style="width: 5%; margin-left: 5px;" [class.open-green]="isActive"
                           class="arrow-down-mensualite arrow-green-down">
                      </div>
                  </button>
              </div>
              @if(isActive) {
              <div class="box-gray">
                  <div class="prices">
                      @if(listFormulesExpansionProduct | ExpansionBottomColorPipe : 'FORMULE-GROUPAMA_SECURITE') {
                        <div class="price">
                            Dont {{datas.selectTarificationDone | MntFormattedPipe : 'CTT02' : datas.periodicite}}
                            <span class="expansion-infos"
                                  [style.color]="listFormulesExpansionProduct | ExpansionBottomColorPipe : 'FORMULE-GROUPAMA_SECURITE' ">
                                  Groupama Sécurité<sup>(3)</sup>
                            </span>
                        </div>
                      }
                      @if(listFormulesExpansionProduct | ExpansionBottomColorPipe : 'FORMULE-GROUPAMA_SECURITE_RENTE_EDUCATION') {
                        <div class="price">
                            Dont {{datas.selectTarificationDone | MntFormattedPipe : 'RED02' : datas.periodicite}}
                            <span class="expansion-infos"
                                  [style.color]="listFormulesExpansionProduct | ExpansionBottomColorPipe : 'FORMULE-GROUPAMA_SECURITE_RENTE_EDUCATION'">
                                  Groupama Sécurité Rente Éducation<sup>(4)</sup>
                            </span>
                        </div>
                      }
                      @if(listFormulesExpansionProduct | ExpansionBottomColorPipe : 'FORMULE-GROUPAMA_GAV') {
                        <div class="price">
                            Dont {{datas.selectTarificationDone | MntFormattedPipe : 'GAV' : datas.periodicite}}
                            <span class="expansion-infos"
                                  [style.color]="listFormulesExpansionProduct | ExpansionBottomColorPipe : 'FORMULE-GROUPAMA_GAV' ">
                                        Groupama Garantie des Accidents de la Vie
                            </span>
                        </div>
                      }
                      @if(listFormulesExpansionProduct | ExpansionBottomColorPipe : 'FORMULE-GROUPAMA_SERENITE_OBSEQUES') {
                        <div class="price">
                            Dont {{datas.selectTarificationDone | MntFormattedPipe : 'OBSEQUES' : datas.periodicite}}
                            <span class="expansion-infos"
                                  [style.color]="listFormulesExpansionProduct | ExpansionBottomColorPipe : 'FORMULE-GROUPAMA_SERENITE_OBSEQUES' ">
                                    Groupama Sérénité Obsèques<sup>(4)</sup>
                            </span>
                        </div>
                      }
                  </div>
              </div>
              }
          </div>
        }

        <br>
        @if(datas.eligibites.length === 0) {
          <div style="color: #bf2727; text-align: center;margin-top: 20px;">
              <p style="background-color: rgba(238,238,238,255);padding-top: 0.5pc; height: 40px;">
                  Pour découvrir l'approche tarifaire adaptée à votre profil, cochez la/les case(s) ci-dessus
              </p>
          </div>
        }

        <div style="display: flex;flex-grow: 1;justify-content: center;margin-top: 40px;margin-bottom: 20px;">
            <app-button-normal type="GREEN" [invalid]="datas.eligibites.length === 0 && !eligibitesEmprunt"
                               title="Être rappelé(e) par un conseiller"
                               (onClick)="openDialogConseiller(datas.user, datas.produits)"></app-button-normal>
        </div>

    </div>

    @if(datas.eligibites.length > 0) {
      <div style="width: 100%;font-style: italic;font-size: 0.6rem;line-height: 20px"
           [innerHTML]="datas | FooterLibelleSelfcarePipe : eligibitesEmprunt">
      </div>
    }
</ng-container>

